import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { Chart } from 'react-google-charts';

const MapChart = ({ title, series, categories, }) => {
  const mapData = [['Country', 'Count']];
  for (let i = 0; i < categories.length; i++) {
    mapData.push([categories[i], series[0].data[i]]);
  }

  const options = {
    region: 'world', // Ensure global view to prevent cropping (e.g., Japan)
    resolution: 'countries', // Display at country level
    colorAxis: { colors: ['#e5f5ff', '#3b82f6'] }, // Light blue to dark blue gradient
    backgroundColor: '#f8fafc',
    datalessRegionColor: '#f5f5f5',
    defaultColor: '#f5f5f5',
    tooltip: { textStyle: { fontName: "'Inter', sans-serif", fontSize: 12 } },
    legend: { textStyle: { fontName: "'Inter', sans-serif", fontSize: 14 } },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        minHeight: '500px', // Ensure sufficient height for map visibility
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: '1.1rem',
          fontWeight: 600,
          color: '#1a2027',
          mb: 2,
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>
      <Box sx={{ width: '100%', height: '100%', minHeight: '450px' }}>
        <Chart
          chartType="GeoChart"
          width="100%"
          height="100%"
          data={mapData}
          options={options}
        />
      </Box>
    </Box>
  );
};

export default MapChart;